import React from 'react';
import { SectionWrapper } from '../common';
import { problems } from '../../data/problems';

const styles = {
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '24px',
    marginBottom: '40px',
  },
  card: {
    backgroundColor: 'rgba(239, 68, 68, 0.05)',
    border: '1px solid rgba(239, 68, 68, 0.1)',
    borderRadius: '12px',
    padding: '24px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    animation: 'slideUp 0.6s ease forwards',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    backgroundColor: 'rgba(239, 68, 68, 0.1)',
    borderRadius: '12px',
    flexShrink: 0,
  },
  text: {
    fontSize: '16px',
    color: '#e2e8f0',
    fontWeight: '500',
  },
  cta: {
    fontSize: '20px',
    fontWeight: '600',
    color: '#fff',
    textAlign: 'center',
  },
  highlight: {
    color: '#3b82f6',
  },
};

export const Problems = ({ isVisible }) => {
  return (
    <SectionWrapper
      id="probleem"
      title="Herkenbaar?"
      isVisible={isVisible}
      backgroundColor="rgba(15, 23, 42, 0.5)"
    >
      <div style={styles.grid}>
        {problems.map((problem, i) => (
          <div key={i} style={{ ...styles.card, animationDelay: `${i * 0.1}s` }}>
            <span style={styles.icon}>{problem.icon}</span>
            <p style={styles.text}>{problem.text}</p>
          </div>
        ))}
      </div>
      <p style={styles.cta}>
       Wij lossen dit <span style={styles.highlight}>structureel</span> op.
      </p>
    </SectionWrapper>
  );
};
